import { render, staticRenderFns } from "./xdRegister.vue?vue&type=template&id=c93c6d7a&scoped=true"
import script from "./xdRegister.vue?vue&type=script&lang=js"
export * from "./xdRegister.vue?vue&type=script&lang=js"
import style0 from "./xdRegister.vue?vue&type=style&index=0&id=c93c6d7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93c6d7a",
  null
  
)

export default component.exports